import { TurnPhase } from "~/business";
import { translateEn } from "./en";
import { getTranslation } from "./translation";

export const useT = () => {
  const t = (key: string) => {
    const result = getTranslation(translateEn, key);
    if (!result) {
      throw new Error(`could not get translation key ${key}`);
    }
    return result;
  };
  const tPhase = (phase: TurnPhase) => t("phases." + phase);
  return { t, tPhase };
};
